import React from "react";
import PreviewImage from "../assets/previewImage.png";

const CardImage = ({ base64Src, setShowUpload, disabled }) => {
  return (
    <>
      {base64Src ? (
        <div className="w-full text-center px-10">
          <img
            src={`data:image/png;base64, ${base64Src}`}
            width="200"
            height="200"
            alt="AssetImage"
            onClick={(e) => {
              if (disabled) {
                return e.preventDefault();
              }
              setShowUpload(true);
            }}
          />
        </div>
      ) : (
        <div className="max-w:345 text-center px-10">
          <img
            className="h:200"
            src={PreviewImage}
            alt="Not found"
            onClick={(e) => {
              if (disabled) {
                return e.preventDefault();
              }
              setShowUpload(true);
            }}
          />
        </div>
      )}
    </>
  );
};

export default CardImage;
